import React, { useState } from 'react';
import { Dialog, DialogContent } from '../components/ui/dialog';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

// Helper function to parse celebrity name from filename
const parseNameFromFile = (filename) => {
  // Remove file extension and underscores
  const nameWithDesc = filename
    .replace(/\.(png|jpg|jpeg)$/i, '')
    .replace(/_/g, ' ')
    .replace(/\d+$/, '').trim();
  
  // Split by " in " to get name and description
  const parts = nameWithDesc.split(' in ');
  if (parts.length >= 2) {
    return {
      name: parts[0].trim(),
      description: parts.slice(1).join(' in ').trim()
    };
  }
  
  // Try other patterns
  const patterns = [
    /^(.+?)\s+(Luxury.+)$/i,
    /^(.+?)\s+(Combination.+)$/i,
    /^(.+?)\s+(Streetcar.+)$/i,
    /^(.+?)\s+(Ribbed.+)$/i,
    /^(.+?)\s+with\s+(.+)$/i,
    /^(.+?)\s+and\s+(.+)$/i,
  ];
  
  for (const pattern of patterns) {
    const match = nameWithDesc.match(pattern);
    if (match) {
      return {
        name: match[1].trim(),
        description: match[2].trim()
      };
    }
  }
  
  return {
    name: nameWithDesc,
    description: 'PRSVR'
  };
};

// All celebrity images - sorted alphabetically by celebrity name
const ALL_IMAGES = [
  // Ace Hood
  { file: "Ace_Hood_in_red_leather_v_neck.png", name: "Ace Hood", description: "Red Leather V Neck" },
  { file: "Ace_Hood_in_red_luxury_track_pants.png", name: "Ace Hood", description: "Red Luxury Track Pants" },
  { file: "Ace_Hood_in_Suede_Pullover_and_luxury_track_pants.png", name: "Meek Mill", description: "Suede Pullover and Luxury Track Pants" },
  
  // Adrienne Bailon
  { file: "Adrienne_Bailon_in_Red_Leather_Track_Pants.jpg", name: "Adrienne Bailon", description: "Red Leather Track Pants" },
  
  // Anthony Hamilton
  { file: "Anthony_Hamilton_in_the_Coliseum_Bomber_Jacket_at_Grammys_2019.jpg", name: "Anthony Hamilton", description: "Coliseum Bomber Jacket at Grammys 2019" },
  { file: "Anthony_Hamilton_in_the_Coliseum_Bomber_Jacket.jpg", name: "Anthony Hamilton", description: "Coliseum Bomber Jacket" },
  
  // Ashanti
  { file: "Ashanti_in_Red_Leather_crop_top_and_track_pants.jpg", name: "Ashanti", description: "Red Leather Crop Top and Track Pants" },
  { file: "Ashanti_in_red_leather_set.png", name: "Ashanti", description: "Red Leather Set" },
  
  // Big U
  { file: "Big_Lou_in_the_Camo_Biker_Jacket.jpg", name: "Big U", description: "Camo Biker Jacket" },
  
  // Bow Wow
  { file: "Bow_Wow_in_red_leather_shorts.jpg", name: "Bow Wow", description: "Red Leather Shorts" },
  { file: "Bow_Wow_in_white_leather_shorts.jpg", name: "Bow Wow", description: "White Leather Shorts" },
  { file: "Bow_Wow_Luxury_track_Pants.png", name: "Bow Wow", description: "Luxury Track Pants" },
  
  // Charity Love & Steve Jackson
  { file: "Charity_Love_and_Steve_Jackson_Leather_Tank_and_Luxury_Track_Pants.jpg", name: "Charity Love & Steve Jackson", description: "Leather Tank and Luxury Track Pants" },
  
  // Charlamagne Tha God
  { file: "Charlamagne_tha_god_in_the_black_lab_coat.jpg", name: "Charlamagne Tha God", description: "Black Lab Coat" },
  
  // Chris Brown
  { file: "Chris_Brown_in_PRSVR_Red_Leather_V_Neck.jpg", name: "Chris Brown", description: "Red Leather V Neck" },
  { file: "Chris_Brown_Luxury_Work_Boots.jpg", name: "Chris Brown", description: "Luxury Work Boots" },
  { file: "Chris_Brown_Red_Leather_V_Neck.jpg", name: "Chris Brown", description: "Red Leather V Neck" },
  
  // Columbus Short
  { file: "Columbus_Short_in_Mustard_Racer_Jacket_and_Flight_Pants.jpg", name: "Columbus Short", description: "Mustard Racer Jacket and Flight Pants" },
  
  // D Rose
  { file: "D_Rose_in_PRSVR_beanie.jpg", name: "D Rose", description: "PRSVR Beanie" },
  
  // David Tutera
  { file: "David_Tutera_in_Black_Lab_Coat.jpg", name: "David Tutera", description: "Black Lab Coat" },
  
  // Daymond John
  { file: "Daymond_John_with_Brandon_and_Margaret.jpg", name: "Daymond John", description: "With Brandon and Margaret" },
  
  // Earl Bennett
  { file: "Earl_Bennett_Combination_Cycle_Jacket.png", name: "Earl Bennett", description: "Combination Cycle Jacket" },
  { file: "Earl_Bennett_in_Luxury_Work_Boots.png", name: "Earl Bennett", description: "Luxury Work Boots" },
  { file: "Earl_Bennett_Luxury_Track_Pants.png", name: "Earl Bennett", description: "Luxury Track Pants" },
  
  // EJ King
  { file: "EJ_King_in_Red_Luxury_Track_Pants.png", name: "EJ King", description: "Red Luxury Track Pants" },
  
  // Enitenna
  { file: "Enitenna.jpg", name: "Enitenna", description: "PRSVR" },
  
  // Eve
  { file: "Eve_in_Green_Luxury_Track_Pants.jpg", name: "Eve", description: "Green Luxury Track Pants" },
  
  // Fabolous
  { file: "Fabolous_in_Green_Flight_Suit.jpg", name: "Fabolous", description: "Green Flight Suit" },
  { file: "Fabolous_in_store_with_Ostrich_Duffle.jpg", name: "Fabolous", description: "In Store with Ostrich Duffle" },
  { file: "Fabolous_in_Tan_Flight_Suit.jpg", name: "Fabolous", description: "Tan Flight Suit" },
  { file: "Fabolous_in_the_leather_no_limit_tank.jpg", name: "Fabolous", description: "Leather No Limit Tank" },
  { file: "Fabolous_in_the_white_leather_scoop_neck.png", name: "Fabolous", description: "White Leather Scoop Neck" },
  { file: "Fabolous_in_White_Imprint_Bomber_Jacket.png", name: "Fabolous", description: "White Imprint Bomber Jacket" },
  
  // George Daniels
  { file: "George_Daniels_in_Red_Boomerang_Coat.jpg", name: "George Daniels", description: "Red Boomerang Coat" },
  
  // GetJanet
  { file: "getjanet_Ribbed_Track_Pants.png", name: "GetJanet", description: "Ribbed Track Pants" },
  
  // Groovey Lew
  { file: "Groovey_Lew_in_Satin_Dojo_Jacket_.jpg", name: "Groovey Lew", description: "Satin Dojo Jacket" },
  
  // Hustle Simmons & Rockie Fresh
  { file: "Hustle_Simmons_and_Rockie_Fresh_Leatherman.jpg", name: "Hustle Simmons & Rockie Fresh", description: "Leatherman" },
  
  // Jacob Latimore
  { file: "Jacob_Latimore_in_red_luxury_track_pants.png", name: "Jacob Latimore", description: "Red Luxury Track Pants" },
  { file: "Jacob_Latimore.png", name: "Jacob Latimore", description: "PRSVR" },
  { file: "Jacob_Latimore2.png", name: "Jacob Latimore", description: "PRSVR" },
  
  // Jennifer Williams
  { file: "Jennifer_Williams_in_White_Luxury_Track_Pants.jpg", name: "Jennifer Williams", description: "White Luxury Track Pants" },
  
  // Jeremy Pargo
  { file: "Jeremy_Pargo_in_the_Ribbed_Leather_Sweats.png", name: "Jeremy Pargo", description: "Ribbed Leather Sweats" },
  
  // Jeremih
  { file: "Jermih.png", name: "Jeremih", description: "PRSVR" },
  
  // JT Thompson
  { file: "JT_Thompson_and_B_Williamson_in_Leatherman_Jacket.jpg", name: "JT Thompson & B Williamson", description: "Leatherman Jacket" },
  
  // Kevin Durant
  { file: "Kevin_Durant_in_Cross_Body_Hoodie.jpg", name: "Kevin Durant", description: "Cross Body Hoodie" },
  
  // Kosine
  { file: "Kosine_in_Red_Leather_V_Neck.png", name: "Kosine", description: "Red Leather V Neck" },
  { file: "Kosine_in_white_luxury_track_pants.png", name: "Kosine", description: "White Luxury Track Pants" },
  
  // La La
  { file: "Lala_in_leather_pullover.jpg", name: "La La", description: "Leather Pullover" },
  
  // Larenz Tate
  { file: "Larenz_Tate_in_Luxury_Work_Boots.png", name: "Larenz Tate", description: "Luxury Work Boots" },
  
  // Lashontae
  { file: "Lashontae_in_leather_pullover.png", name: "Lashontae", description: "Leather Pullover" },
  { file: "Lashontae_in_White_Ribbed_Leather_track_pants.png", name: "Lashontae", description: "White Ribbed Leather Track Pants" },
  
  // Lecrae
  { file: "Lecrae_in_the_black_combination_cycle_.jpg", name: "Lecrae", description: "Black Combination Cycle" },
  
  // Lil Durk
  { file: "Lil_Durk_on_set_in_Satin_Dojo_Jacket.jpg", name: "Lil Durk", description: "Satin Dojo Jacket" },
  { file: "Lil_Durk_Streetcar_Coat.jpg", name: "Lil Durk", description: "Streetcar Coat" },
  
  // Lil Rell
  { file: "Lil_Rell_on_set_in_the_Ribbed_Moto_Jacket_with_Collar.jpg", name: "Lil Rell", description: "Ribbed Moto Jacket with Collar" },
  
  // Lupe Fiasco
  { file: "Lupe_Fiasco_in_store_at_PRSVR.jpg", name: "Lupe Fiasco", description: "In Store at PRSVR" },
  
  // Marcus Troy
  { file: "Marcus_Troy_in_Leatherman_Jacket_and_Backpack.png", name: "Marcus Troy", description: "Leatherman Jacket and Backpack" },
  { file: "Marcus_Troy_with_Subterfuge_Briefcase.png", name: "Marcus Troy", description: "Subterfuge Briefcase" },
  
  // Mars Phillips
  { file: "Mars_Phillips.jpg", name: "Mars Phillips", description: "PRSVR" },
  
  // Meek Mill
  { file: "Meek_Mill_in_Royal_Blue_Luxury_Track_Pants.jpg", name: "Meek Mill", description: "Royal Blue Luxury Track Pants" },
  
  // Mike Epps
  { file: "Mike_Epps.jpg", name: "Mike Epps", description: "PRSVR" },
  
  // Ne-Yo
  { file: "Ne-Yo_in_the_Luxury_Track_Pants_and_Black_Work_Boots.jpg", name: "Ne-Yo", description: "Luxury Track Pants and Black Work Boots" },
  { file: "Ne-yo_in_the_luxury_track_pants_and_work_boots.jpg", name: "Ne-Yo", description: "Luxury Track Pants and Work Boots" },
  { file: "Neyo_in_the_black_leather_track_pants_and_luxury_work_boots.jpg", name: "Ne-Yo", description: "Black Leather Track Pants and Luxury Work Boots" },
  
  // Necole Kane
  { file: "Necole_Kane_in_the_ribbed_leather_track_pants.png", name: "Necole Kane", description: "Ribbed Leather Track Pants" },
  
  // Nelly
  { file: "Nelly_in_Red_Leather_Hoodie.jpg", name: "Nelly", description: "Red Leather Hoodie" },
  { file: "Nelly_in_Red_Leather_Tank.jpg", name: "Nelly", description: "Red Leather Tank" },
  { file: "Nelly_in_white_luxury_track_pants.png", name: "Nelly", description: "White Luxury Track Pants" },
  
  // Nick Cannon
  { file: "Nick_Cannon_in_Gold_Winter_Coat.jpg", name: "Nick Cannon", description: "Gold Winter Coat" },
  
  // Nicki Minaj
  { file: "Nicki_Minaj_dancing_in_Luxury_Track_Pants.png", name: "Nicki Minaj", description: "Dancing in Luxury Track Pants" },
  { file: "Nicki_Minaj_in_Luxury_Track_Pants.jpg", name: "Nicki Minaj", description: "Luxury Track Pants" },
  { file: "Nicki_Minaj_on_set_in_Black_Luxury_Track_Pants.jpg", name: "Nicki Minaj", description: "Black Luxury Track Pants" },
  
  // PJ Rose
  { file: "PJ_Rose_in_Custom_Leather_Shorts.png", name: "PJ Rose", description: "Custom Leather Shorts" },
  
  // Po Johnson
  { file: "Po_Johnson_in_black_leather_shorts.png", name: "Po Johnson", description: "Black Leather Shorts" },
  { file: "Po_Johnson_in_Red_Leather_Polo.png", name: "Po Johnson", description: "Red Leather Polo" },
  
  // Rae Holliday
  { file: "Rae_Holliday_in_Leather_Cardigan.png", name: "Rae Holliday", description: "Leather Cardigan" },
  { file: "Rae_Holliday.png", name: "Rae Holliday", description: "PRSVR" },
  
  // Rockie Fresh
  { file: "Rockie_Fresh_in_Leatherman_and_Luxury_Track_Pants.jpg", name: "Rockie Fresh", description: "Leatherman and Luxury Track Pants" },
  
  // Royce da 5'9"
  { file: "Royce_the_5_9_in_Camo_Flight_Jacket_2.jpg", name: "Royce da 5'9\"", description: "Camo Flight Jacket" },
  { file: "Royce_the_5_9_in_Subterfuge_Denim_Jacket.jpg", name: "Royce da 5'9\"", description: "Subterfuge Denim Jacket" },
  { file: "Royce_the_5_9_in_the_Camo_Flight_Jacket.jpg", name: "Royce da 5'9\"", description: "Camo Flight Jacket" },
  
  // Ryan Henry
  { file: "Ryan_Henry_in_Black_and_Yellow_Flight_Suit.jpg", name: "Ryan Henry", description: "Black and Yellow Flight Suit" },
  
  // Spiff TV
  { file: "Spiff_TV_in_Gambino_Track_Jacket.jpg", name: "Spiff TV", description: "Gambino Track Jacket" },
  { file: "Spiff_TV_in_red_leather_track_pants.png", name: "Spiff TV", description: "Red Leather Track Pants" },
  
  // Steelo Brim
  { file: "Steelo_Brim_in_the_Stash_Pants.jpg", name: "Steelo Brim", description: "Stash Pants" },
  { file: "Steelo.jpg", name: "Steelo Brim", description: "PRSVR" },
  
  // Steve Aoki
  { file: "Steve_Aoki_in_Samaritan_Shirt.jpg", name: "Steve Aoki", description: "Samaritan Shirt" },
  
  // Steven Jackson
  { file: "Steven_Jackson.jpg", name: "Steven Jackson", description: "PRSVR" },
  
  // Swizz Beatz
  { file: "Swizz_Beats_in_White_luxury_track_pants_and_leather_shorts.jpg", name: "Swizz Beatz", description: "White Luxury Track Pants and Leather Shorts" },
  
  // Tee Tee
  { file: "Tee_Tee_in_Boomerang_Coat.jpg", name: "Tee Tee", description: "Boomerang Coat" },
  
  // Teyana Taylor
  { file: "Teyana_Taylor_in_Red_Leatherman_and_Track_Pants.jpg", name: "Teyana Taylor", description: "Red Leatherman and Track Pants" },
  
  // Tyrese
  { file: "Tyrese_in_the_quilted_leather_polo.png", name: "Tyrese", description: "Quilted Leather Polo" },
  
  // Ugo Mozie
  { file: "Ugo_Mozie_in_black_leatherman_jacket.png", name: "Ugo Mozie", description: "Black Leatherman Jacket" },
  { file: "Ugo_Mozie_in_Leatherman.png", name: "Ugo Mozie", description: "Leatherman" },
  
  // Waka Flocka
  { file: "Waka_Flocka_in_green_luxury_track_pants.jpg", name: "Waka Flocka", description: "Green Luxury Track Pants" },
  { file: "Waka_Flocka_on_IG_in_leather_track_pants.png", name: "Waka Flocka", description: "Leather Track Pants" },
  
  // Willie the Kid
  { file: "Willie_the_Kid_in_Ribbed_Moto_Jacket.jpg", name: "Willie the Kid", description: "Ribbed Moto Jacket" },
  { file: "Willie_the_Kid.jpg", name: "Willie the Kid", description: "PRSVR" },
  
  // Wyclef Jean
  { file: "Wyclef_Jean_in_Gambino_Track_Suit_Fit.jpg", name: "Wyclef Jean", description: "Gambino Track Suit" },
  
  // Yeahlano
  { file: "Yeahlano_in_a_custom_white_combination_cycle_jacket.png", name: "Yeahlano", description: "Custom White Combination Cycle Jacket" },
  
  // Zendaya
  { file: "Zendaya_in_pink_leather_shorts.jpg", name: "Zendaya", description: "Pink Leather Shorts" },
  { file: "Zendaya_in_Red_Leather_Polo_and_Luxury_Track_Pants.jpg", name: "Zendaya", description: "Red Leather Polo and Luxury Track Pants" },
  { file: "Zendaya_in_White_Leather_Polo_and_Luxury_Track_Pants.jpg", name: "Zendaya", description: "White Leather Polo and Luxury Track Pants" },
];

const CelebritiesInPRSVR = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});
  const [failedImages, setFailedImages] = useState({});

  const handleImageLoad = (index) => {
    setLoadedImages(prev => ({ ...prev, [index]: true }));
  };

  const handleImageError = (index) => {
    setFailedImages(prev => ({ ...prev, [index]: true }));
  };

  const handlePrev = () => {
    if (selectedImage !== null) {
      let newIndex = selectedImage - 1;
      while (newIndex >= 0 && failedImages[newIndex]) newIndex--;
      if (newIndex < 0) {
        newIndex = ALL_IMAGES.length - 1;
        while (newIndex > selectedImage && failedImages[newIndex]) newIndex--;
      }
      setSelectedImage(newIndex);
    }
  };

  const handleNext = () => {
    if (selectedImage !== null) {
      let newIndex = selectedImage + 1;
      while (newIndex < ALL_IMAGES.length && failedImages[newIndex]) newIndex++;
      if (newIndex >= ALL_IMAGES.length) {
        newIndex = 0;
        while (newIndex < selectedImage && failedImages[newIndex]) newIndex++;
      }
      setSelectedImage(newIndex);
    }
  };

  // Count loaded images
  const loadedCount = Object.keys(loadedImages).length;
  const failedCount = Object.keys(failedImages).length;

  return (
    <div className="min-h-screen bg-black text-white pt-20">
      {/* Hero Section */}
      <div className="relative py-16 px-6 text-center bg-gradient-to-b from-gray-900 to-black">
        <h1 className="text-4xl md:text-6xl font-black mb-4 tracking-tight">
          CELEBRITIES IN <span className="text-red-600">PRSVR</span>
        </h1>
        <p className="text-gray-400 text-lg max-w-2xl mx-auto">
          From red carpets to music videos, see how A-list celebrities rock PRSVR's signature leather and luxury pieces.
        </p>
        <div className="mt-4 text-sm text-gray-500">
          {ALL_IMAGES.length} Photos
        </div>
      </div>

      {/* Masonry Grid Gallery */}
      <div className="container mx-auto px-4 py-12">
        <div className="columns-2 md:columns-3 lg:columns-4 xl:columns-5 gap-4 space-y-4">
          {ALL_IMAGES.map((image, index) => (
            !failedImages[index] && (
              <div
                key={index}
                className="break-inside-avoid cursor-pointer group relative overflow-hidden rounded-lg"
                onClick={() => setSelectedImage(index)}
              >
                {/* Placeholder blur effect */}
                {!loadedImages[index] && (
                  <div className="absolute inset-0 bg-gray-800 animate-pulse rounded-lg min-h-[200px]" />
                )}
                
                {/* Lazy loaded image */}
                <img
                  src={`/celebrities/${image.file}`}
                  alt={`${image.name} in ${image.description}`}
                  loading="lazy"
                  onLoad={() => handleImageLoad(index)}
                  onError={() => handleImageError(index)}
                  className={`w-full h-auto transition-all duration-500 group-hover:scale-105 ${
                    loadedImages[index] ? 'opacity-100' : 'opacity-0'
                  }`}
                />
                
                {/* Hover overlay with name */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  <h3 className="text-white font-black text-lg uppercase tracking-wide">{image.name}</h3>
                  <p className="text-red-500 text-sm font-medium">{image.description}</p>
                </div>
                
                {/* Always visible name badge at bottom */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <h3 className="text-white font-bold text-sm truncate">{image.name}</h3>
                </div>
              </div>
            )
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      <Dialog open={selectedImage !== null} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-5xl bg-black/95 border-gray-800 p-0">
          {selectedImage !== null && (
            <div className="relative">
              {/* Close button */}
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 z-10 w-10 h-10 bg-black/50 hover:bg-black/80 rounded-full flex items-center justify-center transition-colors"
              >
                <X className="w-6 h-6 text-white" />
              </button>

              {/* Navigation arrows */}
              <button
                onClick={handlePrev}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-black/50 hover:bg-black/80 rounded-full flex items-center justify-center transition-colors"
              >
                <ChevronLeft className="w-8 h-8 text-white" />
              </button>
              <button
                onClick={handleNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-black/50 hover:bg-black/80 rounded-full flex items-center justify-center transition-colors"
              >
                <ChevronRight className="w-8 h-8 text-white" />
              </button>

              {/* Main image */}
              <img
                src={`/celebrities/${ALL_IMAGES[selectedImage].file}`}
                alt={`${ALL_IMAGES[selectedImage].name} in ${ALL_IMAGES[selectedImage].description}`}
                className="w-full max-h-[80vh] object-contain"
              />

              {/* Caption */}
              <div className="p-6 text-center border-t border-gray-800">
                <h3 className="text-white font-black text-2xl mb-1 uppercase tracking-wide">
                  {ALL_IMAGES[selectedImage].name}
                </h3>
                <p className="text-red-500 font-medium">
                  {ALL_IMAGES[selectedImage].description}
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  {selectedImage + 1} / {ALL_IMAGES.length}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* CTA Section */}
      <div className="py-16 px-6 text-center border-t border-gray-800">
        <h2 className="text-2xl md:text-3xl font-black mb-4">
          WEAR WHAT THEY WEAR
        </h2>
        <p className="text-gray-400 mb-6 max-w-xl mx-auto">
          Shop the same signature PRSVR pieces worn by your favorite celebrities.
        </p>
        <a
          href="/shop"
          className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-4 rounded-none transition-colors"
        >
          SHOP NOW
        </a>
      </div>
    </div>
  );
};

export default CelebritiesInPRSVR;
